"use strict";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(Draggable);
// gsap.registerPlugin(InertiaPlugin);

const ViewportSize = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    extraLarge: 'extraLarge',
}

class StoryPage {
    constructor() {
        this._scrollTimelines = [];

        this._viewportSize = this._identifyViewportSize();
    }

    initialize() {
        // Lenis
        const lenis = new Lenis()
        function raf(time) {
            lenis.raf(time);
            requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);

        window.onload = () => this._handleWindowLoad();
        window.onresize = () => this._handleWindowResize();
    }

    _identifyViewportSize() {
        const windowWidth = window.innerWidth;
        let viewportSize;

        if (windowWidth < 750) {
            viewportSize = ViewportSize.small;
        } else if (windowWidth < 990) {
            viewportSize = ViewportSize.medium;
        } else if (windowWidth < 1200) {
            viewportSize = ViewportSize.large;
        } else {
            viewportSize = ViewportSize.extraLarge;
        }

        return viewportSize;
    }

    _handleWindowLoad() {

        document.querySelector("#storyPage").classList.add("loaded");

        // Initial animation
        gsap.timeline()
            .fromTo(
                '.heroSection .backgrounds',
                { opacity: 0 },
                { opacity: 1, duration: 0.5 },
                "showTitle"
            )
            .fromTo(
                '.heroSection .title',
                { y: 50, autoAlpha: 0 },
                { y: 0, autoAlpha: 1, duration: 0.5 },
                "+=0.2"
            )
            .fromTo(
                '.heroSection .title',
                { backgroundPosition: '100%' },
                { backgroundPosition: '0%', ease: "linear", duration: 0.25 },
                "-=0.25"
            );

        this._initializeScrollTimelines();


        this._initializeScrollspy();
    }

    _handleWindowResize() {
        // Reload timelines if window size type changes
        const newViewportSize = this._identifyViewportSize();
        if (newViewportSize != this._viewportSize) {
            console.log("<<< Old window type: ", this._viewportSize);
            console.log("<<< New window type: ", newViewportSize);
            this._viewportSize = newViewportSize;
            this._initializeScrollTimelines();
        }
    }

    _initializeScrollspy() {
        const menu = document.querySelector(".storiesNav");
        const hyperPersonalizedScrollspy = new Scrollspy({ menu });
        hyperPersonalizedScrollspy.init();

        const scrollspyElemnts = menu.querySelectorAll(".scrollspy");
        for (let index = 0; index < scrollspyElemnts.length; index++) {
            const scrollspyElement = scrollspyElemnts[index];
            const targetElementQuerySelector = scrollspyElement.getAttribute("href");
            const targetElement = document.querySelector(targetElementQuerySelector);
            if (targetElement) {
                const timeline = gsap.timeline({
                    scrollTrigger: {
                        id: `storyNavScrollspy${index}Timeline`,
                        trigger: targetElement,
                        start: 'top 50%',
                        end: "bottom 50%",
                        onToggle: (self) => {
                            if (self.isActive) {
                                document.querySelector(".storiesNav .active")?.classList.remove("active");
                                scrollspyElement.parentElement.classList.add("active");
                            }
                        },
                        scrub: 0,
                        markers: false,
                    }
                });
                console.log("<<< timeline: ", timeline)
                this._scrollTimelines.push(timeline);
            }
        }
    }

    _initializeScrollTimelines() {

        // Kill any existing timelines
        let scrollTriggers = ScrollTrigger.getAll()
        for (const scrollTrigger of scrollTriggers) {
            scrollTrigger.kill(true)
        }
        for (const timeline of this._scrollTimelines) {
            timeline.kill(true);
        }

        // Clear up any previous timelines
        this._scrollTimelines = [];

        // Intilaize animations
        console.log("<<< this._viewportSize: ", this._viewportSize)
        if (this._viewportSize === ViewportSize.small) {
            this._setupScrollTimelinesForSmallViewport();
        } else if (this._viewportSize === ViewportSize.medium || this._viewportSize === ViewportSize.large) {
            this._setupScrollTimelinesForMediumViewport();
        } else {
            this._setupScrollTimelinesForLargeViewport();
        }

        // Preplay timelines
        this._prePlayTimelines();
    }

    _setupScrollTimelinesForSmallViewport() {
        const self = this;

        // TODO: implement

        // const socialValidationTimeline = gsap.timeline({
        //     scrollTrigger: {
        //         id: 'socialValidation',
        //         trigger: '#socialValidationSection',
        //         start: 'top 75%',
        //         end: '+=200',
        //         scrub: 0,
        //         markers: false,
        //     },
        // })
        //     .fromTo('#socialValidationSection .title span', { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, stagger: { each: 0.1 }, duration: 1 })
        //     .fromTo('#socialValidationSection .background', { autoAlpha: 0 }, { autoAlpha: 1, duration: 1 }, "-=0.4")
        //     .fromTo('#reviewersCarousel', { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, duration: 1 }, "<");
        // this._scrollTimelines.push(socialValidationTimeline);
    }

    _setupScrollTimelinesForMediumViewport() {
        const self = this;
        // TODO: implement

        // const socialValidationTimeline = gsap.timeline({
        //     scrollTrigger: {
        //         id: 'socialValidation',
        //         trigger: '#socialValidationSection',
        //         start: 'top 75%',
        //         end: '+=200',
        //         scrub: 0,
        //         markers: false,
        //     },
        // })
        //     .fromTo('#socialValidationSection .title span', { autoAlpha: 0, y: 50 }, { autoAlpha: 1, y: 0, stagger: { each: 0.1 }, duration: 1 })
        //     .fromTo('#socialValidationSection .background', { autoAlpha: 0 }, { autoAlpha: 1, duration: 1 }, "-=0.4")
        //     .fromTo('#reviewersCarousel', { autoAlpha: 0, y: 20 }, { autoAlpha: 1, y: 0, duration: 1 }, "<");
        // this._scrollTimelines.push(socialValidationTimeline);
    }

    _setupScrollTimelinesForLargeViewport() {
        const self = this;

        // Hero timeline
        const heroTitleGradientAnimation = gsap.timeline()
            .fromTo(
                '.heroSection .title',
                { backgroundPosition: '0%' },
                { backgroundPosition: '100%' },
            )
            .fromTo(
                '.heroSection .title',
                { backgroundPosition: '100%' },
                { backgroundPosition: '0%' },
            );
        const heroSectionTimeline = gsap.timeline({
            scrollTrigger: {
                id: 'heroSection',
                trigger: 'body',
                start: 'top top',
                end: 'bottom bottom',
                endTrigger: '.heroSection',
                scrub: 0,
                markers: false,
            },
        })
            .fromTo(
                '.heroSection .title',
                { scale: 1 },
                { scale: 0.86 }
            )
            .add(
                gsap.timeline()
                    .fromTo(
                        '.heroSection .title',
                        { backgroundPosition: '0%' },
                        { backgroundPosition: '100%', ease: "linear" },
                    )
                    .fromTo(
                        '.heroSection .title',
                        { backgroundPosition: '100%' },
                        { backgroundPosition: '0%', ease: "linear" },
                    ),
                "<"
            );
        this._scrollTimelines.push(heroSectionTimeline);

        // Stories section timeline
        const storiesSectionTimeline = gsap.timeline({
            scrollTrigger: {
                id: 'storiesSection',
                trigger: '.storiesSection',
                start: 'top 50%',
                end: 'top 0%',
                scrub: 0,
                markers: false,
            },
        });
        storiesSectionTimeline.fromTo(
            '.storiesSection',
            { opacity: 0 },
            { opacity: 1 },
        );
        this._scrollTimelines.push(storiesSectionTimeline);

        // Type 1 stories
        const group1StoryElements = document.querySelectorAll("#storiesGroup1 .story");
        for (let index = 0; index < group1StoryElements.length; index++) {
            if (index == 0) {
                continue;
            }

            const storyElement = group1StoryElements[index];
            const storyImageElementId = storyElement.getAttribute("data-image");
            const storyImageElement = document.querySelector(storyImageElementId);
            const storyTimeline = gsap.timeline({
                scrollTrigger: {
                    id: `type1Story${index}Timeline`,
                    trigger: storyElement,
                    start: 'top 100%',
                    end: 'top 0%',
                    scrub: 0,
                    markers: false,
                }
            })
            storyTimeline.from(
                storyImageElement,
                { y: "100%", ease: "linear" },
                `story-loop-${index}`
            );

            for (let previousElementIndex = 0; previousElementIndex < index; previousElementIndex++) {
                const previousStoryElement = group1StoryElements[previousElementIndex];
                const previousStoryImageElementId = previousStoryElement.getAttribute("data-image");
                const previousStoryImageElement = document.querySelector(previousStoryImageElementId);
                const oldBrightness = 100 - ((index - 1 - previousElementIndex) * 4);
                const newBrightness = 100 - ((index - previousElementIndex) * 4);
                const oldScale = 1.0 - ((index - 1 - previousElementIndex) * 0.045);
                const newScale = 1.0 - ((index - previousElementIndex) * 0.045);
                storyTimeline.fromTo(
                    previousStoryImageElement,
                    {
                        scaleX: oldScale,
                        scaleY: oldScale,
                        filter: `brightness(${oldBrightness}%)`,
                    },
                    {
                        scaleX: newScale,
                        scaleY: newScale,
                        filter: `brightness(${newBrightness}%)`,
                    },
                    `story-loop-${index}`
                );
            }

            this._scrollTimelines.push(storyTimeline);
        }

        // Type 2 stories
        const group2StoryImageElements = document.querySelectorAll("#storiesGroup2 .image");
        for (let index = 0; index < group2StoryImageElements.length; index++) {
            const storyImageElement = group2StoryImageElements[index];
            const storyImageFrameElement = storyImageElement.querySelector(".imageFrame");
            const storyImageTimeline = gsap.timeline({
                scrollTrigger: {
                    id: `type2Story${index}Timeline`,
                    trigger: storyImageElement,
                    start: 'top 100%',
                    end: 'bottom 0%',
                    scrub: 0,
                    markers: false,
                }
            })
            storyImageTimeline.fromTo(
                storyImageFrameElement,
                { scale: 0.5 },
                { scale: 1, ease: "linear" },
            )
            this._scrollTimelines.push(storyImageTimeline);
        }

        // Type 3 stories
        const group3StoryImageElements = document.querySelectorAll("#storiesGroup3 .image");
        for (let index = 0; index < group3StoryImageElements.length; index++) {
            const storyImageElement = group3StoryImageElements[index];
            const storyImageFrameElement = storyImageElement.querySelector(".imageFrame");
            const storyImageTimeline = gsap.timeline({
                scrollTrigger: {
                    id: `type3Story${index}Timeline`,
                    trigger: storyImageElement,
                    start: 'top 100%',
                    end: 'bottom 0%',
                    scrub: 0,
                    markers: false,
                }
            })
            storyImageTimeline.fromTo(
                storyImageFrameElement,
                { scale: 0.6 },
                { scale: 1, ease: "linear" },
            )
            this._scrollTimelines.push(storyImageTimeline);
        }

        // Type 4 stories
        const group4StoryImageElements = document.querySelectorAll("#storiesGroup4 .image");
        for (let index = 0; index < group4StoryImageElements.length; index++) {
            const storyImageElement = group4StoryImageElements[index];
            const storyImageFrameElement = storyImageElement.querySelector(".noFrameImage");
            const storyImageTimeline = gsap.timeline({
                scrollTrigger: {
                    id: `type4Story${index}Timeline`,
                    trigger: storyImageElement,
                    start: 'top 100%',
                    end: 'bottom 0%',
                    scrub: 0,
                    markers: false,
                }
            });
            storyImageTimeline.fromTo(
                storyImageFrameElement,
                { scale: 0.9 },
                { scale: 1 },
            );
            storyImageTimeline.fromTo(
                storyImageFrameElement,
                { scale: 1 },
                { scale: 0.8 },
            );
            this._scrollTimelines.push(storyImageTimeline);
        }

        // Type 5 stories
        const group5StoryImageElements = document.querySelectorAll("#storiesGroup5 .image");
        for (let index = 0; index < group5StoryImageElements.length; index++) {
            const storyImageElement = group5StoryImageElements[index];
            const storyImageFrameElement = storyImageElement.querySelector(".noFrameImage");
            const storyImageTimeline = gsap.timeline({
                scrollTrigger: {
                    id: `type5Story${index}Timeline`,
                    trigger: storyImageElement,
                    start: 'top 100%',
                    end: 'bottom 0%',
                    scrub: 0,
                    markers: false,
                }
            });
            storyImageTimeline.fromTo(
                storyImageFrameElement,
                { scale: 0.9 },
                { scale: 1 },
            );
            storyImageTimeline.fromTo(
                storyImageFrameElement,
                { scale: 1 },
                { scale: 0.8 },
            );
            this._scrollTimelines.push(storyImageTimeline);
        }

        // Type 6 stories
        const teamMemberElements = document.querySelectorAll("#storiesGroup6 .teamMember");
        for (let index = 0; index < teamMemberElements.length; index++) {
            const teamMemberElement = teamMemberElements[index];
            const storyImageTimeline = gsap.timeline({
                scrollTrigger: {
                    id: `type6Story${index}Timeline`,
                    trigger: teamMemberElement,
                    start: 'top 100%',
                    end: 'top 0%',
                    scrub: 0,
                    markers: false,
                }
            })
            storyImageTimeline.fromTo(
                teamMemberElement,
                { scale: 0.8 },
                { scale: 1 },
            )
            this._scrollTimelines.push(storyImageTimeline);
        }
    }

    _prePlayTimelines() {
        // Preplay animations to ensure smoothness on animatiing during
        // window scroll. Note that we play animations in reverse order.
        for (let index = this._scrollTimelines.length - 1; index >= 0; index--) {
            const timeline = this._scrollTimelines[index];
            timeline.progress(1).progress(0);
        }
    }
}

const storyPage = new StoryPage();
storyPage.initialize();